export default {
  data() {
    return {
      currentWave: null,
    };
  },

  computed: {
  },

  methods: {
    calculateCurrentWaveForHealing() {
      const currentDate = new Date(Date.now());
      const currentYear = currentDate.getFullYear();
      const q1HealEnd = new Date(`May 1, ${currentYear} 00:00:00`);
      const q2HealEnd = new Date(`August 1, ${currentYear} 00:00:00`);
      const q3HealEnd = new Date(`November 1, ${currentYear} 00:00:00`);
      const q4HealEnd = new Date(`February 1, ${currentYear + 1} 00:00:00`);
      if(currentDate < q1HealEnd) {
        this.currentWave = `Q1-${currentYear}`;
      } else if(currentDate < q2HealEnd) {
        this.currentWave = `Q2-${currentYear}`;
      } else if(currentDate < q3HealEnd) {
        this.currentWave = `Q3-${currentYear}`;
      } else if(currentDate < q4HealEnd) {
        this.currentWave = `Q4-${currentYear}`;
      };
    },
    
    openPopup(kpi, wave) {
      if(kpi.SurveyWave.find(x => x.Name == wave)) {
        if (this.selectedKpi == kpi && this.selectedWave == wave) {
          this.hidePopup();
        } else {
          kpi.ShowPopup = true; 
          this.selectedKpi = kpi;
          this.selectedWave = wave;
          this.showPopup = true; 
        } 
      } else {
        this.hidePopup();
      }
    },

    hidePopup() {
      this.selectedKpi = null;
      this.selectedWave = null;
      this.showPopup = false;
    },
  }
};
